import { INavLink } from './nav-link.model';

export interface ITopToolbarConfig {
  title: string;
  menuItems: INavLink[];
  quickActions: INavLink[];
}

export function emptyTopToolbarConfig(): ITopToolbarConfig {
  return {
    title: '',
    menuItems: [],
    quickActions: [],
  };
}
